<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1000px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              用户名称：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.name"
              placeholder="请输入用户名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectEmployeeFun()"
            >
              选择人员
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectEmployee="selectEmployeeFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { systemUserPageListApi } from '@/api/user'
export default {
  name: 'EmployeeList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'employee_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择人员',
            method: 'selectEmployee'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            name: '',
            status: '1',
            sorts: '1,2'
          }
        }
      },
      multipleSelection: [],
      isPaging: true
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'provinceName', filterColumn: 'province_name', label: '省区', width: 120 },
          { prop: 'cityName', filterColumn: 'city_name', label: '城市', width: 120 },
          { prop: 'name', label: '名称', width: 100 },
          { prop: 'department', label: '部门', width: 160 },
          { prop: 'remark', label: '备注' }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.search.name = ''
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      systemUserPageListApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择人员
    selectEmployeeFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择人员',
          type: 'warning'
        })
        return
      } else {
        if (this.multipleSelection.length > 1) {
          this.$message({
            message: '只能选择一个人员',
            type: 'warning'
          })
          return
        }
        this.$emit('selectedEmployeeFun', this.multipleSelection[0])
        this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
